import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatTimezone(timezone: string): string {
  try {
    // Get current date to check if timezone is in DST
    const date = new Date();
    
    // Format: "America/New_York (EDT)" or "Europe/London (BST)"
    const timeZoneName = new Intl.DateTimeFormat('en-US', {
      timeZoneName: 'short',
      timeZone: timezone,
    }).formatToParts(date).find(part => part.type === 'timeZoneName')?.value;

    // Get just the city name from the timezone string
    const city = timezone.split('/').pop()?.replace(/_/g, ' ');
    
    return timeZoneName ? `${city} (${timeZoneName})` : city || timezone;
  } catch (error) {
    return timezone;
  }
}
